import types from '../types/types';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.LOADING_DATA:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
